import(/* webpackMode: "eager" */ "/vercel/path0/src/app/site-shell.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/_global.scss")